import React from 'react'

const NumberRating = (props) => {
  return (
   <div className="text-center pr-5 pl-5 ml-5 mr-5 pb-3">
    <div className="d-flex justify-content-around mb-1">
      {Array.from({ length: props.max }, (_, i) => i + 1).map((num) => (
        <span key={`num-${num}`} className="rating-number">
          {num}
        </span>
      ))}
    </div>
    <div className="d-flex gap-1 align-items-center justify-content-around rating">
      {Array.from({ length: props.max }, (_, i) => i + 1).map((value, idx) => (
        <div className="df-settings__toggle-row">
          <input checked={props?.value == value} disabled={props.disabled} type="checkbox" name={`flexRadioDefault${props.keyId}`} id={`flexRadioDefault${idx}`} onClick={() => !props.disabled && props.onChange && props.onChange(value)} />
        </div>
      ))}
    </div>
  </div>
  )
}

export default NumberRating